import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
function ToastComp(arg) {
  const [show, setShow] = useState(true);

  return (
    <Row>
      <Col xs={6}>
        <ToastContainer position='top-end' containerPosition='position-fixed'>
        
        
        <Toast onClose={() => arg.handler()} show={show} delay={5000} autohide  bg='warning'>
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Message</strong>
            <small></small>
          </Toast.Header>
          <Toast.Body className='Success '>
           {arg.case === 'delete' ? <span> You have deleted successfully!</span> : ""}
           {arg.case === 'add-user' ? <span> User saved successfully!</span> : ""} 
           {arg.case === 'error' ? <span> Some error occured!</span> : ""} 
           {arg.case === 'add-training' ? <span> Training saved successfully!</span> : ""} 
           {arg.case === 'assign-user' ? <span> Activity assigned successfully!</span> : ""} 
           {arg.case === 'unassign-user' ? <span> Un assigned the activity successfully!</span> : ""} 
           {arg.case === 'question-add' ? <span> Question added successfully!</span> : ""}
           {arg.case === 'commu-add' ? <span> Communication saved successfully!</span> : ""}  
           {arg.case === 'assess-add' ? <span> Assessment saved successfully!</span> : ""} 
           {arg.case === 'update-test' ? <span> Assessment status updated successfully!</span> : ""}
           {arg.case === 'pwd-reset' ? <span> Password changed successfully!</span> : ""}  
           {arg.case === 'no-attempt' ? <span> Attempt not allowed.Please contact Admin.</span> : ""}
           {arg.case === 'question-error' ? <span> Please complete the question and proceed.</span> : ""}
           {arg.case === 'session-error' ? <span> Invalid Session.Please login.</span> : ""}
           {arg.case === 'add-project' ? <span> Project created successfully!</span> : ""}
          </Toast.Body>
        </Toast>
        </ToastContainer>
      </Col>
      
    </Row>
  );
}

export default ToastComp;